module.exports = __webpack_public_path__ + "img/flavor1.97a06a41.png";